<ts-dialog title="Create Workspace" (closeDialog)="cancel()">
  <form class="flex flex-col justify-center gap-2 w-full" ts-dialog-body [formGroup]="form">
    <span class="flex flex-row items-center justify-between">
      <p [class.required]="form.get('workspace')?.hasError('required')">Name</p>
      <ts-input
        class="w-1/2"
        placeholder="Workspace name"
        autocomplete="off"
        type="text"
        [roundedBorders]="false"
        formControlName="workspace"
      ></ts-input>
    </span>

    <span class="flex flex-row items-center justify-between">
      <p [class.required]="form.get('subdomain')?.hasError('required')">Subdomain</p>
      <div class="w-1/2">
        <ts-input
          placeholder="Subdomain"
          autocomplete="off"
          type="text"
          [roundedBorders]="false"
          formControlName="subdomain"
          (blur)="onSubdomainBlur()"
        ></ts-input>
        @if (form.get('subdomain')?.value) {
          <div class="text-xs mt-1">
            @if (subdomainStatus === 'checking') {
              <span>Checking availability...</span>
            }
          </div>
        }
      </div>
    </span>
    @if (termsheetUser()) {
      <span class="flex flex-row items-center justify-between">
        <p>Workspace Type</p>
        <ts-select
          class="w-1/2"
          [items]="workspaceTypeOptions"
          itemKey="value"
          itemLabel="label"
          formControlName="workspace_type"
          [uiOptions]="{
            roundedBorders: false,
            placeholder: 'Workspace type',
            size: 'medium',
          }"
        />
      </span>
    }
    @if (subdomainStatus === 'available') {
      <span class="flex flex-row items-center font-normal text-sm gap-1 justify-center text-green-600">
        <ts-icon icon="ts_check-circle-true" [color]="'green'"></ts-icon>
        Subdomain available.
      </span>
    }
    @if (subdomainStatus === 'taken') {
      <span class="flex flex-row items-center font-normal text-sm gap-1 justify-center text-red-600">
        <ts-icon icon="ts_times-circle" [color]="'red'"></ts-icon>
        Subdomain already in use.
      </span>
    }
  </form>

  <div class="ts-dialog-actions-container" ts-dialog-actions>
    <ts-button variant="secondary" (click)="cancel()">Cancel</ts-button>
    <ts-button variant="primary" [loading]="submitting" [disabled]="isCreateDisabled" (click)="create()"
      >Create</ts-button
    >
  </div>
</ts-dialog>
